import api, { apifyPath } from 'api/client';
import { cancelable } from 'api/utils';
import ROUTES from 'routes';
import Route from '@ohmsd/utils/Route';
import ApiCrudStore2 from './ApiCrudStore2';

export const RegExAppLink = /id=?([-a-z\d.]+)\??/i;
export function marketIdFromUrl (url) {
  const m = url.match(RegExAppLink);
  return (m && m[1]) || '';
}

// API has: create, fetchList, getById, update, delete
export default new ApiCrudStore2({
  route: new Route(ROUTES.API.APPS),

  transformIn (app) {
    app.marketId = marketIdFromUrl(app.url);
    return app;
  },
});

export function getDeps (id) {
  return api.get(ROUTES.API.APP_DEPS, { params: { id } });
}

export function getSources (id, source, campaign) {
  return api.get(ROUTES.API.APP_SOURCES, {
    params: { id },
    query: {
      type: source ? 'campaign' : campaign ? 'adgroup' : 'source',
      source,
      campaign,
    },
  });
}

export function getPreview (url) {
  return cancelable({
    method: 'GET',
    url: ROUTES.API.APPS_PREVIEW,
    query: { url },
  });
}

export function getPreviewPng (id) {
  const route = apifyPath(ROUTES.API.APP_PREVIEW_PNG);
  return new Route(route).stringify({ params: { id } });
}
